import React from "react"
import { LoadingButton } from "@mui/lab"
import { Box, FormControl, FormControlLabel, FormLabel, Grid, Paper, Radio, RadioGroup, TextField, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles";
import { useSearchParams } from "react-router-dom";
import { useLoadingState } from "../Context";
import useIsMobile from "./isMobile";

export default function SearchBar() {

    const [searchParams] = useSearchParams()

    let passedQasQueryParam = searchParams.get('q');
    let searchByValue = searchParams.get('searchBy') || 'waybill';
    let textFieldValue = searchParams.get('ref_awb_number') || '';

    if (passedQasQueryParam) {
        textFieldValue = passedQasQueryParam;
    }

    const theme = useTheme();
    const [searchBy, setSearchBy] = React.useState(searchByValue)
    const [value, setValue] = React.useState(textFieldValue)
    const { isLoading } = useLoadingState()
    const isMobile = useIsMobile()

    const placeholderText = searchBy === 'reference' ? "Enter your order ID" : "Enter your tracking number";

    return (
        <Paper elevation={0} sx={{
            p: { xs: 3, sm: 5 },
            position: 'relative',
            overflow: 'hidden',
        }}>
            <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: 4,
                backgroundImage: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
            }} />
            <form method="get">
                <Grid container spacing={2.5}>
                    <Grid item xs={12}>
                        <Typography variant="h6" fontWeight={700} gutterBottom>
                            Track Your Order
                        </Typography>
                        <FormControl>
                            <FormLabel sx={{ fontSize: '0.85rem', mb: 0.5 }}>Track By</FormLabel>
                            <RadioGroup row name="searchBy" value={searchBy} onChange={(e) => setSearchBy(e.target.value)}>
                                <FormControlLabel value="reference" control={<Radio size="small" />} label="Order ID" />
                                <FormControlLabel value="waybill" control={<Radio size="small" />} label="Tracking Number" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    bgcolor: '#f8f9fa',
                                    pr: 0,
                                    '&.Mui-focused': {
                                        bgcolor: '#fff',
                                    },
                                },
                            }}
                            fullWidth
                            name="ref_awb_number"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            placeholder={placeholderText}
                            InputProps={{
                                endAdornment: !isMobile ? (
                                    <LoadingButton
                                        loading={isLoading}
                                        type="submit"
                                        disabled={value === ''}
                                        variant="contained"
                                        disableElevation
                                        sx={{
                                            width: 150,
                                            height: 55,
                                            borderRadius: '0 12px 12px 0 !important',
                                            //background: 'linear-gradient(135deg, #1565C0 0%, #1976d2 100%)',
                                            color: '#fff',
                                            '&:hover': {
                                                //background: 'linear-gradient(135deg, #0d47a1 0%, #1565C0 100%)',
                                            },
                                            '&.Mui-disabled': {
                                                background: '#e0e0e0',
                                                color: '#9e9e9e',
                                            },
                                        }}>
                                        Search
                                    </LoadingButton>
                                ) : null
                            }}
                        />
                    </Grid>
                    {isMobile && (
                        <Grid item xs={12}>
                            <LoadingButton
                                loading={isLoading}
                                type="submit"
                                size="large"
                                disabled={value === ''}
                                variant="contained"
                                fullWidth
                                sx={{
                                    py: 1.5,
                                    backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                                    color: '#fff',
                                    '&:hover': {
                                        backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                                    },
                                    '&.Mui-disabled': {
                                        background: '#e0e0e0',
                                        color: '#9e9e9e',
                                    },
                                }}
                            >
                                Search
                            </LoadingButton>
                        </Grid>
                    )}
                </Grid>
            </form>
        </Paper>
    )

}
